//fgOpacity, bgOpacity, and windowOpacity can also be 'flashing'.
//TODO: get better defaults from design
import { CaptionsState } from './types/reducerTypes'
import { AnyAction } from 'redux'
import { platformStoreSet } from '../../../shared/helpers'

const defaultState: CaptionsState = {
  fontSize: '100%',
  fontStyle: 'sans-serif',
  captionStyle: 'default',
  fgColor: '#FFF',
  bgColor: '#000',
  windowColor: 'black',
  fgOpacity: '1',
  bgOpacity: '1',
  windowOpacity: '1',
  textShadowValue: 'none',
  enabled: false,
}

export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'SET_CAPTION_STATE':
      platformStoreSet('captionsOn', action.payload.enabled)
      return { ...state, ...action.payload }
    default:
      return state
  }
}
